// Core Module
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

// External Module 
import { NgxSpinnerModule } from "ngx-spinner";
// import { FacebookModule } from "ngx-facebook";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LivechatWidgetModule } from '@livechat/angular-widget';

// Component 
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SectionComponent } from './section/section.component';
import { TrackingComponent } from './tracking/tracking.component';
import { FindABranchComponent } from './find-a-branch/find-a-branch.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
// Animation 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LandingComponent,
    HeaderComponent,
    FooterComponent,
    AboutUsComponent,
    SectionComponent,
    TrackingComponent,
    FindABranchComponent,
    ContactUsComponent,
    // AppearDirectiveDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    // FacebookModule.forRoot(),
    LivechatWidgetModule,
    BrowserAnimationsModule,
    SlickCarouselModule,
    // AppearDirectiveDirective
    // RouterModule.forRoot(routes, { anchorScrolling: 'enabled'})
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [Title],
  bootstrap: [AppComponent]
})

export class AppModule { }

